import { render, staticRenderFns } from "./drawback.vue?vue&type=template&id=713d30b2&scoped=true&"
import script from "./drawback.vue?vue&type=script&lang=js&"
export * from "./drawback.vue?vue&type=script&lang=js&"
import style0 from "./drawback.vue?vue&type=style&index=0&id=713d30b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713d30b2",
  null
  
)

export default component.exports